/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown> }} Usage_Overage_Min_HintInputs */



/**
* | output |
* | --- |
* | "Minimum: {amount} (current period usage)" |
*
* @param {Usage_Overage_Min_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const usage_overage_min_hint = /** @type {((inputs: Usage_Overage_Min_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Overage_Min_HintInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Mindestens: ${i?.amount} (aktueller Verbrauch)`)
	return /** @type {LocalizedString} */ (`Minimum: ${i?.amount} (current period usage)`)
});